import { useCallback, useEffect, useRef } from "react";

import { useUpdateHeightCallback } from "../../Internals/UpdateHeightCallbackContext/UpdateHeightCallbackContext";
import { useResizeObserver } from "../../../Helpers/ReactUtils/Hooks/UseResizeObserver";
import { useUUID } from "../../../../../Common/UUID";

export const useUpdateTableCellOnResize = () => {
    const updateHeight = useUpdateHeightCallback();
    const id = useUUID();
    const cellRef = useRef<HTMLTableCellElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    const onResizeCb = useCallback(() => {
        if (contentRef.current && cellRef.current) {
            const divRect = contentRef.current.getBoundingClientRect();
            const divHeight = divRect.height;
            const tdRect = cellRef.current.getBoundingClientRect();
            const realContentHeight = divHeight + (divRect.y - tdRect.y);
            updateHeight(id, realContentHeight);
        }
    }, []);

    const divObserver = useResizeObserver({ onResize: onResizeCb });

    useEffect(() => {
        if (contentRef.current) {
            divObserver.observe(contentRef.current);
        }
    }, []);

    return { cellRef: cellRef, contentRef: contentRef };
};
